import type { PrivateHouseMissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation/';
import { GridItem, Link, Message, RadioField, RadioInput } from '@flos/react-ui';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { missingInformationAtom } from '../../../../../recoil/atoms/missingInformationAtom';
import { useState } from 'react';
import ViewInformationModal from '../../../../../shared_components/ViewInformationModal/ViewInformationModal';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { allCoverablesAtom } from '../../../../../recoil/atoms/allCoverablesAtom';
import { getCoverableIndex } from '../../../../../utils/coverablesUtil';
const HouseHasBuildingReport = ({
    houseMissingDTO
}: {
    houseMissingDTO: PrivateHouseMissingInformationDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setMissingInformation = useSetRecoilState(missingInformationAtom);
    const { fixedId } = houseMissingDTO;
    const [choice, setChoice] = useState<string>(houseMissingDTO.hasBuildingReportChoice ?? '');
    const [coverables, setCoverables] = useRecoilState(allCoverablesAtom);
    const buildings =
        houseMissingDTO.flavourCode === 'top_prh_house'
            ? coverables.houses ?? []
            : coverables.holidayHomes ?? [];
    const coverableIndex = getCoverableIndex(buildings, houseMissingDTO.fixedId ?? '');
    const [showModal, setShowModal] = useState<boolean>(false);

    const handleChoiceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        setChoice(value);
        updateMissingInformationProperty({
            hasBuildingReport: value === 'Yes',
            hasBuildingReportChoice: value
        });
        const updatedCoverables = [...buildings];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            outputBuildingReportPending: value === 'Yes' ? true : undefined
        };
        setCoverables((prev) => ({
            ...prev,
            [houseMissingDTO.flavourCode === 'top_prh_house' ? 'houses' : 'holidayHomes']:
                updatedCoverables
        }));
    };

    const updateMissingInformationProperty = (
        updateValue: PrivateHouseMissingInformationDTO
    ): void => {
        setMissingInformation((previousState) => {
            const updateHouse = previousState.privateHouse?.map((item) => {
                if (item.fixedId !== fixedId) return item;
                return {
                    ...item,
                    ...updateValue
                };
            });
            return {
                ...previousState,
                privateHouse: updateHouse
            };
        });
    };

    return (
        <>
            <GridItem span={12}>
                <h6>{getHippoText('DSS-ADDITIONAL-INFORMATION-BUILDINGREPORT-TITLE')}</h6>
            </GridItem>
            <RadioField value={choice} onChange={handleChoiceChange}>
                <RadioInput label={'Ja'} value="Yes" />
                <RadioInput label={'Nej'} value="No" />
            </RadioField>
            {houseMissingDTO.hasBuildingReport && (
                <Message
                    id={`additional-warning-label-${fixedId ?? ''}`}
                    theme="warning"
                    className="coverage-warning paragraph--small u-spacing-stack-s"
                    title={getHippoText('DSS-ADDITIONAL-INFORMATION-BUILDINGREPORT-WARNING')}
                />
            )}
            <Link
                onClick={() => {
                    setShowModal(true);
                }}
                theme="logo"
            >
                {getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK')}
            </Link>
            {showModal && (
                <ViewInformationModal
                    showModal={showModal}
                    modalProps={{
                        title: getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK'),
                        description: getHippoText(
                            'DSS-ADDITIONAL-INFORMATION-INFOLINK-BUILDINGREPORT'
                        )
                    }}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </>
    );
};
export default HouseHasBuildingReport;
